import { FC, ReactElement } from 'react';

import { Skeleton } from '../../../../../../../components';

import './ProductSidebarSkeletons.scss';

interface ProductSidebarSkeletonsProps {
    className?: string;
}

export const ProductSidebarSkeletons: FC<ProductSidebarSkeletonsProps> = ({
    className = '',
}): ReactElement => (
    <div className={`product-sidebar-skeletons ${className}`}>
        <Skeleton className="product-sidebar-skeletons__skeleton" />
    </div>
);
